import { IAction, ISpeakerFee } from '../../schemas';
import {
	GET_SPEAKERFEE_LIST,
	ADD_SPEAKERFEE,
	UPDATE_SPEAKERFEE,
	DELETE_SPEAKERFEE,
} from '../constant';

const initState: any = {};

export default function budgetsReducer(
	preState = initState,
	action: IAction<any>
): any {
	const { type, data } = action;
	switch (type) {
		case GET_SPEAKERFEE_LIST:
			return { ...data };
		case ADD_SPEAKERFEE:
			const newdata = [...preState.data, data];
			return { data: newdata, total: preState.total };
		case UPDATE_SPEAKERFEE:
			const index = preState.data.findIndex(
				(item) => item.id === action.data.id
			);
			const updateData = [
				...preState.data.slice(0, index),
				{
					...data,
				},
				...preState.data.slice(index + 1),
			];
			return { data: updateData, total: preState.total };
		case DELETE_SPEAKERFEE:
			return {
				data: preState.data.filter((d) => d.id !== action.data.id),
				total: preState.total,
			};
		default:
			return preState;
	}
}
